import { useI18n } from "vue-i18n"

const useWeekdayFormatter = () => {
  const { t } = useI18n()

  const formatWeekdays = (day: string): string => {
    const weekDaysMap: Record<string, string> = {
      "1": t("weekdays.sunday"),
      "2": t("weekdays.monday"),
      "3": t("weekdays.tuesday"),
      "4": t("weekdays.wednesday"),
      "5": t("weekdays.thursday"),
      "6": t("weekdays.friday"),
      "7": t("weekdays.saturday"),
    }

    return weekDaysMap[day] || "Invalid Day"
  }

  return { formatWeekdays }
}

const adjustHourlyDataForTimeZone = (data: Record<string, number>): Record<string, number> => {
  const userTimezoneOffsetHours = -(new Date().getTimezoneOffset() / 60);
  const adjustedData: Record<string, number> = {};
  Object.entries(data).forEach(([hourStr, value]) => {
    let hour = parseInt(hourStr);
    let adjustedhour = (hour + userTimezoneOffsetHours + 24) % 24;
    adjustedData[adjustedhour.toString()] = value;
  })

  return adjustedData;
}

export { useWeekdayFormatter, adjustHourlyDataForTimeZone }
